// app/javascript/apps/navbar/googleOneTap.ts
//
// What the navbar does about Google One Tap after each current-user fetch.
//
// One Tap needs https://accounts.google.com/gsi/client (~100 KB, plus its
// stylesheet and iframe). The navbar used to fetch it during page boot for
// every signed-out visitor. Now the first load waits for whenPageIdle() and
// happens once per page. If the script is already there (a later
// `user:updated` while still signed out) we prompt straight away, as before.

export type OneTapAction =
  /** Signed in, or no client id: leave One Tap alone. */
  | 'none'
  /** GSI is already loaded: initialise and prompt now. */
  | 'prompt'
  /** GSI not loaded and not yet scheduled: load it once the page is idle. */
  | 'schedule'
  /** A deferred load is already pending; it will prompt when it lands. */
  | 'wait';

export interface OneTapState {
  signedIn: boolean;
  hasClientId: boolean;
  scriptLoaded: boolean;
  loadScheduled: boolean;
}

export function oneTapAction(state: OneTapState): OneTapAction {
  if (state.signedIn || !state.hasClientId) return 'none';
  if (state.scriptLoaded) return 'prompt';
  if (state.loadScheduled) return 'wait';
  return 'schedule';
}
